var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-tab-item', {
    attrs: {
      "value": _vm.JOIN.value
    }
  }, [_c('div', {
    staticClass: "page-section-wrap"
  }, [_c('section', {
    staticClass: "page-section"
  }, [_c('div', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "3"
    }
  }, [_c('h2', {
    staticClass: "tit"
  }, [_vm._v("회원가입")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "9"
    }
  }, [_c('div', [_c('div', {
    staticClass: "mb-10"
  }, [_c('h4', {
    staticClass: "tit tit--xs"
  }, [_vm._v("회원 가입")])]), _c('p', {
    staticClass: "page-text"
  }, [_vm._v(" 캐터옥션에 작품을 위탁하시거나, 경매에 응찰하기 위해서 반드시 회원가입을 하셔야 합니다. 회원가입은 별도의 연회비 없이, 캐터옥션 홈페이지 및 프리뷰 전시장에서 가입 가능합니다. 캐터옥션 회원은 경매 안내 이메일, 문자 등을 받아 보실 수 있습니다. ")])]), _c('div', {
    staticClass: "mt-18 mt-md-30"
  }, [_c('div', {
    staticClass: "mb-10"
  }, [_c('h4', {
    staticClass: "tit tit--xs"
  }, [_vm._v("홈페이지 회원가입")])]), _c('p', {
    staticClass: "page-text"
  }, [_vm._v(" 홈페이지 우측 상단에 있는 <회원가입>에서 작성해 주시기 바랍니다. 회원가입 후 로그인이 필요합니다. 우측 상단의 <로그인>을 통하여, 본인인증을 완료하면 누구나 참여가 가능합니다 ")]), _c('p', {
    staticClass: "page-text primary--text mt-16 mt-md-26"
  }, [_vm._v(" ※ 회원가입 중 어려운 점이 발생할 경우 언제든 문의 주시기 바랍니다. 02-395-6987 ")])]), _c('v-divider', {
    staticClass: "grey-cb my-30 my-md-36"
  }), _c('div', [_c('div', {
    staticClass: "mb-10"
  }, [_c('h4', {
    staticClass: "tit tit--xs"
  }, [_vm._v("Membership Registration")])]), _c('p', {
    staticClass: "page-text"
  }, [_vm._v(" Membership Registration is required in order to bid or sell at KATA Auction. Membership registration is available on the KATA Auction website and preview exhibition hall without an annual fee. Members can receive auction news by email and SMS. ")])]), _c('div', {
    staticClass: "mt-18 mt-md-30"
  }, [_c('div', {
    staticClass: "mb-10"
  }, [_c('h4', {
    staticClass: "tit tit--xs"
  }, [_vm._v("Online Registration")])]), _c('p', {
    staticClass: "page-text"
  }, [_vm._v(" Please fill out the <Member Registration> section at the top right on the website. After registering, you need to log in. Anyone can participate after completing identity verification through <Login> at the top right on the website. ")]), _c('p', {
    staticClass: "page-text primary--text mt-16 mt-md-26"
  }, [_vm._v(" ※ If you encounter any difficulties during membership registration, please contact us. 02-395-6987 ")])])], 1)], 1)], 1)])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }